import { CountryCode, getCountriesForTimezone } from 'countries-and-timezones'
import type { PricingPlan } from '../types/pricing'

const getMonthlyPlans = (): PricingPlan[] => [
  {
    id: 'standard',
    name: 'Creative',
    price: pricingByGeo.NZ.standard,
    billingPeriod: 'monthly',
    description:
      'For growing design studios and professionals that want to speed up their design process',
    buttonText: 'Upgrade Now',
    highlighted: true,
    features: [
      { name: 'Unlimited FF&E schedules', included: true },
      { name: 'Finishes & Accessories', included: true },
      { name: 'Custom branding', included: true },
      { name: 'Purchase Orders', included: true },
      { name: 'Client Approval Tracking', included: true },
      { name: 'Procurement Tracking', included: true },
      { name: 'Accounting Integration (Xero)', included: true },
      { name: 'Unlimited team member accounts', included: true },
      { name: 'Free Support & Training', included: true }
    ]
  }
]

const getYearlyPlans = (): PricingPlan[] => {
  return getMonthlyPlans().map((plan) => ({
    ...plan,
    billingPeriod: 'monthly',
    price: plan.price * 0.8 // 20% discount
  }))
}

export const getPricingPlans = (
  billingPeriod: 'monthly' | 'yearly'
): PricingPlan[] => {
  return billingPeriod === 'monthly' ? getMonthlyPlans() : getYearlyPlans()
}

type GeoCode = 'AU' | 'US' | 'GB' | 'NZ'

export const mapCountryToGeo = (country: CountryCode): GeoCode => {
  switch (country) {
    case 'AU':
      return 'AU'
    case 'US':
      return 'US'
    case 'GB':
      return 'GB'
    default:
      return 'NZ'
  }
}

export const getGeoFromTimezone = () => {
  const country =
    getCountriesForTimezone(Intl.DateTimeFormat().resolvedOptions().timeZone)[0]
      ?.id ?? 'NZ'

  return mapCountryToGeo(country)
}

export const pricingByGeo = {
  NZ: {
    currencySymbol: '$',
    standard: 59,
    subtitle:
      'Prices are in New Zealand Dollars (NZD) and include GST.'
  },
  AU: {
    currencySymbol: '$',
    standard: 59,
    subtitle:
      'Prices are in Australian Dollars (AUD) and include GST.'
  },
  US: {
    currencySymbol: '$',
    standard: 59,
    subtitle:
      'Prices are in US Dollars (USD) and include VAT.'
  },
  GB: {
    currencySymbol: '£',
    standard: 49,
    subtitle:
      'Prices are in British Pounds (GBP) and include VAT.'
  },
  EU: {
    currencySymbol: '€',
    standard: 49,
    subtitle:
      'Prices are in Euros (EUR) and include VAT.'
  }
}
